export default `
    <link href='/snippets-style/brand-info.css' rel='stylesheet' />
    <div class="ro-footer--brandWrap">
      <div class="ro-footer--brandInfo">
        <div class="ro-footer--brandInfo__txt">
          Produsele Favbet.ro sunt detinute si operate de Favbet Online, companie cu sediul in Bucuresti pe Calea Grivitei, nr 136, inregistrata sub numarul J40/14188/18.11.2015, cu capital social 1.000.100 RON si numarul de inregistrare fiscala 35246629.
        </div>
      </div>
    </div>
    <div class="ro-footer--brandWrap">
      <div class="copyright">© 2020 Favbet Ltd. Toate drepturile rezervate.</div>
    </div>
`;
